import SidebarComponent from 'components/sidebar/Sidebar';
import { METADATA_SUB_PATHS } from 'constants/index';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { accountStore } from 'store/accountStore';
import { default as CustomBreadcrumb } from '../breadcrumb/Breadcrumb';
import './BasePage.css';
import PageHeader from './PageHeader';

export interface BaseProps {
  children: React.ReactNode;
}

const BasePage: React.FC<BaseProps> = observer(({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname.split('/')[1];
  const defaultOpenKeys = METADATA_SUB_PATHS.includes(currentPath) ? ['metadata'] : [];
  const breadcrumbs = CustomBreadcrumb();
  const breadcrumbItems = breadcrumbs.map((breadcrumb, index) => ({
    title: breadcrumb.title,
    key: index,
    href: breadcrumb.url,
  }));

  useEffect(() => {
    if (!accountStore.isInit()) {
      accountStore.init().then();
    }
  }, []);

  return (
    <SidebarComponent currentPath={currentPath} defaultOpenKeys={defaultOpenKeys}>
      <PageHeader
        userName={accountStore.getAccount()?.username || ''}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="base-page-component">{children}</div>
    </SidebarComponent>
  );
});

export default React.memo(BasePage);
